import type { LocalStorage } from '@shared/app/scripts/services/local-storage';

export class Persist {
  constructor(
    private $log: ng.ILogService,
    private localStorage: LocalStorage,
  ) {}

  set = (key, value) => {
    if (this.localStorage) {
      if (angular.isString(value)) {
        this.localStorage.setItem(key, value);
      } else {
        this.localStorage.setItem(key, JSON.stringify(value));
      }
    } else {
      this.$log.warn('[Persist] Localstorage not supported!');
    }
  };

  get = (key) => {
    let value = null;
    if (this.localStorage) {
      value = this.localStorage.getItem(key);
    } else {
      this.$log.warn('[Persist] Localstorage not supported!');
    }
    return value;
  };

  remove = (key) => {
    if (this.localStorage) {
      this.localStorage.removeItem(key);
    } else {
      this.$log.warn('[Persist] Localstorage not supported!');
    }
  };
}

/*
 * Service to handle localStorage
 */
angular
  .module('v6CoreModule')
  .service('persist', ($log: ng.ILogService, localStorage: LocalStorage) => {
    return new Persist($log, localStorage);
  });
